import { WarningAmberOutlined } from '@mui/icons-material';
import { Button, CardContainer } from 'finara-components';
import React from 'react';

interface ErrorStateProps {
  title?: string;
  message?: string;
  error?: Error | { message?: string } | null;
  showRetry?: boolean;
  onRetry?: () => void;
  retryText?: string;
  iconSize?: number;
  useCard?: boolean;
  className?: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Error al cargar los datos',
  message,
  error,
  showRetry = true,
  onRetry,
  retryText = 'Reintentar',
  iconSize = 48,
  useCard = true,
  className = '',
}) => {
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  const errorMessage =
    message || error?.message || 'No se pudieron cargar los datos. Por favor, intenta nuevamente.';

  const content = (
    <div className={`text-center p-8 ${className}`}>
      <WarningAmberOutlined className="text-red-500 mb-4" style={{ fontSize: iconSize }} />
      <h3 className="text-lg font-semibold text-brand-white mb-2">{title}</h3>
      <p className="text-muted mb-4">{errorMessage}</p>
      {showRetry && (
        <Button variant="black" onClick={handleRetry}>
          {retryText}
        </Button>
      )}
    </div>
  );

  if (useCard) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <CardContainer>{content}</CardContainer>
      </div>
    );
  }

  return content;
};
